import axios from "axios";
import store from './../index'

// Отчёты вкладки «Аналитика» поверх AnalyticsEvents:
// «Переходы по экранам» (AnalyticsPageViewReport/*): page_view, логин × экран × месяц;
// «Активность отчётов» (ReportActivity/*): входы (page_view экранов отчётов) и выгрузки (report_export).

async function downloadXlsx(request, fileName) {
  try {
    const { data } = await request();

    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    // Ответ запрошен как blob, поэтому текст ошибки (400, { error }) читаем из него
    let text = 'Не удалось сформировать отчёт';
    try {
      const body = error.response?.data;
      if (body instanceof Blob) {
        text = JSON.parse(await body.text()).error || text;
      } else if (body?.error) {
        text = body.error;
      }
    } catch (parseError) {
      window.console.log(parseError);
    }
    store.commit('SET_SNACKBAR', { text, timeout: 7500, color: 'error', linkText: '', show: true });
    throw error;
  }
}

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // ---- Активность отчётов ----
    REPORT_ACTIVITY_FILTER_OPTIONS: async () => {
      const { data } = await axios.get('/ReportActivity/GetFilterOptionsAsync');

      return data;
    },

    REPORT_ACTIVITY_REPORT: async (_, search) => {
      const { data } = await axios.post('/ReportActivity/GetReportAsync', search || {});

      return data;
    },

    DOWNLOAD_REPORT_ACTIVITY_REPORT: (_, search) => downloadXlsx(
      () => axios.post('/ReportActivity/DownloadAsync', search || {}, { responseType: 'blob' }),
      'ReportActivity.xlsx'
    ),

    // ---- Переходы по экранам ----
    // Справочники фильтра: экраны с заголовками, роли, экраны по умолчанию
    PAGE_VIEW_REPORT_FILTER_OPTIONS: async () => {
      const { data } = await axios.get('/AnalyticsPageViewReport/GetFilterOptionsAsync');

      return data;
    },

    PAGE_VIEW_REPORT: async (_, search) => {
      const { data } = await axios.post('/AnalyticsPageViewReport/GetReportAsync', search || {});

      return data;
    },

    DOWNLOAD_PAGE_VIEW_REPORT: async (_, search) => {
      try {
        const { data } = await axios.post('/AnalyticsPageViewReport/DownloadAsync', search || {}, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'PageViewReport.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return true;
      } catch (error) {
        // Ответ запрошен как blob, поэтому текст ошибки (400, { error }) читаем из него
        let text = 'Не удалось сформировать отчёт';
        try {
          const body = error.response?.data;
          if (body instanceof Blob) {
            text = JSON.parse(await body.text()).error || text;
          } else if (body?.error) {
            text = body.error;
          }
        } catch (parseError) {
          window.console.log(parseError);
        }
        store.commit('SET_SNACKBAR', {
          text,
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        });
        throw error;
      }
    },
  }
};
